define("calendar/components/calendar/onboarding/modals/trial-opt-in", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "ember-concurrency-ts"], function (_exports, _component, _templateFactory, _object, _service, _component2, _tracking, _emberConcurrency, _emberConcurrencyTs) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"ember-concurrency-ts"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Modal @close={{@closeTrialOptInModal}} as |modal|>
    <modal.card @portrait={{false}} class="tPF--modalCard">
      <modal.card-header class="u--p__b__sm">
        <h2 class="tPF--plan__title u--text--center u--m__t">
          {{t "authorization.sign_up_trial.page_title"}}
        </h2>
        <p class="u--text--center u--text--light u--m__0">
          {{t "authorization.sign_up_trial.sub_title"}}
        </p>
      </modal.card-header>
      <modal.card-body class="u--p__t__0">
        <div class="tPF--plan tPF--plan—-sm">
          {{#each this.trialOptInPlans as |plan|}}
            <Shared::Upgrade::PlanCard
              @isTrialOptInAtSignup={{false}}
              @onPlanButtonClick={{fn this.handlePlanButtonClick plan.planType}}
              @plan={{plan}}
            />
          {{/each}}
        </div>
      </modal.card-body>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "BPtKVidT",
    "block": "[[[8,[39,0],null,[[\"@close\"],[[30,1]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],[[24,0,\"tPF--modalCard\"]],[[\"@portrait\"],[false]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card-header\"]],[[24,0,\"u--p__b__sm\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,\"h2\"],[14,0,\"tPF--plan__title u--text--center u--m__t\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"authorization.sign_up_trial.page_title\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--text--center u--text--light u--m__0\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"authorization.sign_up_trial.sub_title\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,2,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"tPF--plan tPF--plan—-sm\"],[12],[1,\"\\n\"],[42,[28,[37,3],[[28,[37,3],[[30,0,[\"trialOptInPlans\"]]],null]],null],null,[[[1,\"          \"],[8,[39,4],null,[[\"@isTrialOptInAtSignup\",\"@onPlanButtonClick\",\"@plan\"],[false,[28,[37,5],[[30,0,[\"handlePlanButtonClick\"]],[30,3,[\"planType\"]]],null],[30,3]]],null],[1,\"\\n\"]],[3]],null],[1,\"      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]]],[\"@closeTrialOptInModal\",\"modal\",\"plan\"],false,[\"shared/modal\",\"t\",\"each\",\"-track-array\",\"shared/upgrade/plan-card\",\"fn\"]]",
    "moduleName": "calendar/components/calendar/onboarding/modals/trial-opt-in.hbs",
    "isStrictMode": false
  });

  let TrialOptInComponent = (_class = class TrialOptInComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);

      _initializerDefineProperty(this, "router", _descriptor, this);

      _initializerDefineProperty(this, "plans", _descriptor2, this);

      _initializerDefineProperty(this, "trialOptInPlans", _descriptor3, this);

      (0, _emberConcurrencyTs.taskFor)(this.loadTrialPlans).perform();
    }

    *loadTrialPlans() {
      this.trialOptInPlans = yield this.plans.trialOptInPlans();
    }

    handlePlanButtonClick(planType) {
      this.router.transitionTo('plans.plan', planType, {
        queryParams: {
          isMonthly: true
        }
      });
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "plans", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "trialOptInPlans", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  }), _applyDecoratedDescriptor(_class.prototype, "loadTrialPlans", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "loadTrialPlans"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handlePlanButtonClick", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handlePlanButtonClick"), _class.prototype)), _class);
  _exports.default = TrialOptInComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TrialOptInComponent);
});